import { useState, useEffect } from "react"
import { useParams } from "react-router-dom"
import { Button } from "antd"
import { baseAxiosNoInfo } from "../../../tool/axios"

interface dataType {
    create_time: string // 创建时间
    id: string // 跟进记录主键id
    follow_man_name: string // 跟进门店销售
    visit_store_name: string // 参观门店
    visit_date: string // 进店日期
    follow_level_name: string // 跟进等级名称
    follow_content: string // 沟通内容
    intention_item_name: string // 意向套餐
    childbirth_hospital: string // 分娩医院
    preg_times: string // 胎次，整数类型
    sample_food: string // 是否试吃月子餐
    make_deal: string // 是否签单
    no_deal_reason: string // 未签单原因
    remark: string // 备注
}

export default function () {

    const param: { id: string } = useParams()
    const [page, setPage] = useState<number>(1)
    const [data, setData] = useState<dataType[]>([])
    const [showLoadBtn, setShowLoadBtn] = useState<boolean>(true)

    useEffect(() => {
        baseAxiosNoInfo('/keeper/check_in/detail/visit_store_records', {
            params: { page, check_in_id: param.id }
        }).then((res: any) => {
            if (res.records.length > 0) {
                let d = data
                setData([...d, ...res.records])

            } else {
                setShowLoadBtn(false)
            }
        })
    }, [page])

    return <div className="follow-record">
        {/* 管家中心 -> 入住管理 -> 客户详情 -> 销售进店记录 */}
        {data.length === 0 && '暂无数据'}

        {data.map((el: dataType) => <ul style={{ listStyle: 'none' }}>
            <li>
                <p className="date">创建日期：{el.create_time}</p>
            </li>
            <li>
                <p>跟进销售：{el.follow_man_name}</p>
            </li>
            <li>
                <p>参观门店：{el.visit_store_name} </p>
            </li>
            <li>
                <p>进店日期：{el.visit_date} </p>
            </li>
            <li>
                <p>跟进等级：{el.follow_level_name}</p>
            </li>
            <li>
                <p>沟通内容：{el.follow_content}</p>
            </li>
            <li>
                <p>分娩医院：{el.childbirth_hospital}</p>
            </li>
            <li>
                <p>胎次：{el.preg_times}</p>
            </li>
            <li>
                <p>是否试吃月子餐：{el.sample_food}</p>
            </li>
            <li>
                <p>是否签单：{el.make_deal}</p>
            </li>
            {el.make_deal === '否' && <li>
                <p>未签单原因：{el.no_deal_reason}</p>
            </li>}
            <li>
                <p>备 注：{el.remark}</p>
            </li>
        </ul>)}

        {showLoadBtn && <Button onClick={() => {
            setPage(page + 1)
        }}>加载更多数据</Button>}
    </div>
}